export default __webpack_public_path__ + "static/media/old-drawing.46da73b2.jpeg";